import React, { forwardRef } from 'react';
import './RadioButton.css';

interface RadioButtonProps {
  label?: string;
  id: string | null;
  formik: any;
  value: string;
  name: string;
  additionalClasses?: string;
}

const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ label, id, formik, value, name, additionalClasses }, ref) => {
    const handleChange = () => {
      formik.setFieldValue(name, id);
    };

    console.log('RadioButton---', { label, id, formik, value, name });

    return (
      <label className={`ui-widget-radio ${additionalClasses || ''}`}>
        <input
          type="radio"
          checked={formik.values[name] === id}
          onChange={handleChange}
          name={name}
          value={value}
          ref={ref} // Forward the ref to the input element
        />
        {label && <span>{label}</span>}
        {!label && <span></span>}
      </label>
    );
  },
);

export default RadioButton;
